rdefine('app/products/properties/Website',['backbone'],function(Backbone) {
    return Backbone.Ribs.View.extend({
        tagName:'input',
        className:'form-control input-block-level',
        bindings:{
            el:{
                attr:{
                    placeholder:'model.name'
                },
                value:{
                    events:'change keyup',
                }
            }
        },
        initialize:function(options) {
            this.cform = options.cform;
            this.bindings.el.value.data = 'cform.property_'+this.model.get("id");
        }
    });
});